import {format } from 'date-fns'
export const facts = {
  source_name_ims: { type: "value", name: "source_name", size: 20, sort: { value: "asc" }},
  regulation: { type: "value", sort: { value: "asc" }},
  procedures: { type: "value", size: 250, sort: { value: "asc" } },
  document_type: { type: "value", size: 250, sort: { value: "asc" } },
  document_type: { type: "value", size: 250, sort: { value: "asc" } },
  enabling_and_support: { type: "value", sort: { value: "asc" }},
  country: { type: "value", size: 500, sort: { value: "asc" } },
  extension: { type: "value", sort: { value: "asc" }},
  languages: { type: "value", size:100, sort: { value: "asc" }},
  created_by: { type: "value", size: 10000, sort: { value: "asc" }},
  tags: { type: "value", size: 5000, sort: { value: "asc" }},
  // suggest: { type: "value",  },
  source_sublevel:{ type: 'value', size: 1000, sort: { value: "asc" }},
  division:{type : 'value', size: 250, sort: { value: "asc" }},
  org_level_1:{type : 'value', size: 10, sort: { value: "asc" }},
  org_level_2:{type : 'value', size: 500, sort: { value: "asc" }},
  org_level_3:{type : 'value', size: 10000, sort: { value: "asc" }},
  org_level_4:{type : 'value', size: 10000, sort: { value: "asc" }},
  org_level_5:{type : 'value', size: 10000, sort: { value: "asc" }},
  org_level_6:{type : 'value', size: 10000, sort: { value: "asc" }},
  org_level_7:{type : 'value', size: 1000, sort: { value: "asc" }},
  org_level_8:{type : 'value', size: 250, sort: { value: "asc" }},
  org_level_9:{type : 'value', size: 10, sort: { value: "asc" }},
  org_level_10:{type : 'value', size: 10, sort: { value: "asc" }},
  // last_modified_at:{type:'value'}
  effective_date: {
    type: "range",
    ranges:[
      { from: format(new Date().setDate(new Date().getDate() - 7)), to: new Date(), name: "Last 1 Week" },
      { from: format(new Date().setDate(new Date().getDate() - 30)), to: new Date(), name: "Last 1Months" },
      { from: format(new Date().setDate(new Date().getDate() - 90)), to: new Date(), name: "Last 3 Months" },
      { from: format(new Date().setDate(new Date().getDate() - 180)), to: new Date(), name: "Last 6 Months" },
      { from: format(new Date().setDate(new Date().getDate() - 365)), to: new Date(), name: "Last 1 Year" },
      { from :"1950-10-05T14:48:00.000Z", to:new Date(), name:"all"}
      
    ]
  }


  // modified_at: {
  //   type: 'range',

  //   ranges: [
  //     {
  //       from: '1972-04-13T12:48:33.420Z',
  //       name: 'Within the last 50 years',
  //     },
  //     {
  //       from: '1922-04-13T12:48:33.420Z',
  //       to: '1972-04-13T12:48:33.420Z',
  //       name: '50 - 100 years ago',
  //     },
  //     {
  //       to: '1922-04-13T12:48:33.420Z',
  //       name: 'More than 100 years ago',
  //     },
  //   ],
  // },
};
